import { Navigate, Outlet } from "react-router-dom";

import { AppLayout } from "../_lib/_components";

const PrivateWrapper = () => {
  const isAuthenticated = localStorage.getItem("token");

  if (!isAuthenticated) {
    return <Navigate to={"/login"} />;
  } else {
    return (
      <AppLayout>
        <Outlet />
      </AppLayout>
    );
  }
};

export default PrivateWrapper;
